import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Modal } from 'antd';
import { Grid, Card } from '@material-ui/core';
import MainContainer from '../../../components/MainContainer';
import GuideDocumentList from '../../../components/AdminGuideDocument/List';
import UpdateGuideDocumentModal from '../../../components/AdminGuideDocument/Update/UpdateGuideDocument';

@inject('guideDocumentStore')
@observer
class GuideDocumentPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.props.guideDocumentStore.initGuideDocument();
    }

    componentWillUnmount() {
        this.props.guideDocumentStore.setShowUpdateGuideDocumentModal(false);
    }

    handleCancelUpdateGuideDocumentModal = () => {
        this.props.guideDocumentStore.setShowUpdateGuideDocumentModal(false);
    }

    handleCancelSearchMenuIteModal = () => {
        this.props.guideDocumentStore.setShowSearchMenuItemModal(false);
    }

    render() {
        const { 
            showUpdateGuideDocumentModal, 
            manageGuideDocumentTitle
        } = this.props.guideDocumentStore;

        return (
            <MainContainer title='Guide Document Management' menukey='guidedocuments'>
                <Modal
                    title={manageGuideDocumentTitle}
                    visible={showUpdateGuideDocumentModal}
                    width={800}
                    footer={null}
                    onCancel={this.handleCancelUpdateGuideDocumentModal}
                    zIndex={1000}
                >
                    <UpdateGuideDocumentModal />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <GuideDocumentList />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default GuideDocumentPage